const removeEmptyFields = (obj) => {
  const removedObject = Object.entries(obj)
    .filter(([, v]) => v != null && v !== undefined && v !== '')
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

  return removedObject;
};

export default removeEmptyFields;
